import { ContainerStyle } from "./style";

export const ContainerComponent = props => (
    <ContainerStyle {...props}>
        {props.children}
    </ContainerStyle>
);